// extracted by mini-css-extract-plugin
export default {"add":"Add_add__PfCKj","addIcon":"Add_addIcon__XTfM2","nameLabel":"Add_nameLabel__3bYro","disable":"Add_disable__qQVHD","wrapperNameAndTooltip":"Add_wrapperNameAndTooltip__SIjYA"};